export const idStateHTML = 'cardListLocalsInputState'
export const idCityHTML = 'cardListLocalsInputCity'
export const idDistrictHTML = 'cardListLocalsInputDistrict'
